<div
    class="flex flex-wrap-reverse xsm:flex-nowrap items-center px-4 pb-2 pt-4 sm:px-6 bg-primaryBackground"
>
    <app-header-name class="flex items-center h-fit w-100 xsm:w-fit"></app-header-name>
    <div class="flex items-center h-fit ml-auto">
        <app-folder-controls class="m-0 sm:mr-4"></app-folder-controls>
        <app-search class="mx-6 xl:ml-4 sm:mr-5"></app-search>
        <app-notifications-menu></app-notifications-menu>
    </div>
</div>
